module.exports = __webpack_public_path__ + "static/media/mail.95929ef4.svg";